<template>
  <div class="advanced-config-container">
    <div class="main-content">
      <div class="left-panel">
        <!-- 左上：分组信息 -->
        <div class="section-card section-card-group">
          <div class="section-title">分组信息</div>
          <div class="group-block-container">
            <div v-for="(group, groupIndex) in groupedElinkList" :key="groupIndex" class="group-block">
              <div class="card-header">
                <span class="card-index">{{ group.groupIndex }}</span>
              </div>

              <div class="card-body">
                <div class="elink-details">
                  <div class="elink-list-section">
                    <el-card v-for="(elink, elinkIndex) in group.eLinkSettingList" :key="elinkIndex"
                      class="elink-list-section-card">
                      <div class="detail-item">
                        <span class="item-label">eLink标识：</span>
                        <span class="item-value">{{ elink.uuid }}</span>
                      </div>
                      <div class="detail-item">
                        <span class="item-label">需量(kW)：</span>
                        <span class="item-value">{{ elink.demandMax || 0 }}</span>
                      </div>
                      <div class="detail-item">
                        <span class="item-label">防逆流：</span>
                        <span class="item-value">{{ elink.demandMin > -6000 ? '开启' : '关闭' }}</span>
                      </div>
                      <div class="detail-item">
                        <span class="item-label">无功工作模式：</span>
                        <span class="item-value">{{ getReactiveModeText(elink.reactiveMode) }}</span>
                      </div>
                    </el-card>

                  </div>
                </div>

                <!-- 下部：分组级别设置（可编辑） -->
                <div class="group-settings-section">

                  <!-- 无功工作模式下拉框 -->
                  <div class="setting-item vertical-item">
                    <div class="setting-label">
                      无功工作模式
                    </div>
                    <div class="setting-control">
                      <el-select v-model="group.eLinkSettingList[0].reactiveMode" placeholder="请选择无功工作模式"
                        @change="onReactiveModeChange(group.eLinkSettingList)">
                        <el-option :value="1" label="不出无功"></el-option>
                        <el-option :value="2" label="优先出无功"></el-option>
                        <el-option :value="3" label="优先出有功"></el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <el-empty class="empty-card" v-if="groupedElinkList.length === 0" description="暂无数据"></el-empty>
          </div>


        </div>

        <!-- 左中：参数设置模块 -->
        <div class="section-card">
          <div class="section-title">参数设置</div>
          <div class="section-content">
            <div class="param-form-container">
              <el-form label-position="left" label-width="120px" :model="paramForm" ref="paramFormRef"
                class="param-form">
                <el-form-item label="箱变容量变比" prop="transformerRatio">
                  <template #label>
                    <span>
                      箱变容量变比
                    </span>
                  </template>
                  <div class="form-input-row">
                    <el-input-number v-model="paramForm.transformerRatio" :min="0" :max="1" :step="0.01" :precision="2"
                      placeholder="请输入0~1之间的值" class="transformer-ratio-input" />
                    <el-button type="primary" @click="saveParamSettings" class="save-btn">保存参数设置</el-button>
                  </div>
                </el-form-item>
              </el-form>
              <el-table :data="transformerData" class="transformer-table" v-if="transformerData.length>0">
                <el-table-column label="组名" prop="groupIndex" />
                <el-table-column label="eLink标识" prop="uuid" />
                <el-table-column label="箱变容量变比" prop="transfCapRatio" />

              </el-table>
            </div>
          </div>
        </div>

        <!-- 左下：通信中断储能运行模式 -->
        <div class="section-card" v-if="isDeveloper">
          <div class="section-title">通信中断储能运行模式</div>
          <div class="section-content">
            <div class="communication-mode-container">
              <div class="mode-selection">
                <div class="mode-options">
                  <el-radio-group v-model="formData.communicationMode">
                    <el-radio :label="1">按策略一直运行</el-radio>
                    <el-radio :label="2">按策略运行第二天停机</el-radio>
                    <el-radio :label="3">按策略工作休息制度运行</el-radio>
                  </el-radio-group>
                  <el-button type="primary" @click="saveCommunicationMode">保存运行模式</el-button>
                </div>

                <div class="mode-description">
                  <template v-if="formData.communicationMode === 1">
                    <div class="subtitle">按策略一直运行说明：</div>
                    <div class="desc-text">通信中断时，储能设备将按最后一次下发的策略持续运行，直到通信恢复为止。</div>
                  </template>
                  <template v-else-if="formData.communicationMode === 2">
                    <div class="subtitle">按策略运行第二天停机说明：</div>
                    <div class="desc-text">通信中断时，储能设备将按最后一次下发的策略运行至第二天（00:10）后0功率停机，等待通信恢复。</div>
                  </template>
                  <template v-else>
                    <div class="subtitle">按策略工作休息制度运行说明：</div>
                    <div class="desc-text">
                      通信中断时，储能设备将按照工作日/休息日的设置运行：<br />
                      <div class="sub-item">
                        <div class="sub-item-title">① 无休模式：</div>
                        <div class="sub-item-desc">通信超时后，按策略一直运行。</div>
                      </div>
                      <div class="sub-item">
                        <div class="sub-item-title">② 单休模式：</div>
                        <div class="sub-item-desc">
                          - 周一至周六期间通信中断：按策略运行到本周日（00:10）后0功率停机。<br />
                          - 周日当天通信中断：按策略运行到下周一（00:10）后0功率停机。
                        </div>
                      </div>
                      <div class="sub-item">
                        <div class="sub-item-title">③ 双休模式：</div>
                        <div class="sub-item-desc">
                          - 周一至周五期间通信中断：按策略运行到本周六（00:10）后0功率停机。<br />
                          - 周六当天通信中断：按策略运行到下周一（00:10）后0功率停机。
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧：操作历史 -->
      <div class="right-panel">
        <div class="section-title">高级配置操作历史</div>
        <el-timeline style="max-width: 600px">
          <el-timeline-item v-for="(log) in strategyLogList" :key="log.createTime" :timestamp="log.createTime">
            <!-- 策略历史列表 -->
            <div class="card-container">
              <div class="item-container">
                <span class="title">操作人：</span>
                <span class="content">{{ log.createBy }}</span>
              </div>
              <div class="item-container">
                <span class="title">操作内容：</span>
                <span class="content">{{ log.modifiedContent }}</span>
              </div>
            </div>

          </el-timeline-item>
        </el-timeline>
        <el-empty class="empty-card" v-if="strategyLogList.length === 0" description="暂无数据"></el-empty>
      </div>
    </div>


    <!-- 添加权限校验确认弹窗 -->
    <auth-verify-dialog v-model:visible="authDialogVisible" :stationId="stationId" :isAuth="isAuth"
      :phoneNumber="phoneNumber" @cancel="cancelAuthDialog" @confirm="onConfirmWithCode" />

  </div>
</template>

<script setup>
import { ref, reactive, onMounted, computed, watch, onUnmounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import * as strategyApi from '../StrategyController/api.js'
import { useAppStore } from "@/store/modules/app"
import AuthVerifyDialog from '../StrategyController/components/AuthVerifyDialog.vue'
// 验证码本地缓存（含 5 分钟过期）统一收敛到 smsCodeStore，各页面不再自行读写 localStorage
import { saveSmsCode, clearSmsCode, getSavedSmsCode } from '../StrategyController/smsCodeStore'

// 检查验证码是否有效的函数
// 返回 true=有效 / false=确认无效 / null=无法判定（手机号未就绪或请求异常）
// null 与 false 必须区分：调用方据此决定「是否清除本地验证码」，
// 无法判定时清除会把本来有效的验证码误删。
async function isVerificationValid() {
  // 手机号守卫必须在取码之前：getSavedSmsCode 需要手机号来判断归属，
  // 手机号未就绪时取不到码，若先取码会误判为 false(确认无效)而丢掉 null(无法判定)语义
  if (!phoneNumber.value) {
    return null
  }
  // 本地已过期、或验证码不属于当前手机号时直接判定无效，不必发请求
  const code = getSavedSmsCode(phoneNumber.value)
  if (!code) {
    return false
  }

  try {
    const res = await strategyApi.checkSmsCodeSilent({
      phoneNumber: phoneNumber.value,
      smsCode: code
    })
    return res.code === 200
  } catch (error) {
    console.error('验证码检查失败', error)
    return null
  }
}

const appStore = useAppStore()
const stationId = computed(() => appStore.stationId)

const eLinkList = ref([])
const groupedElinkList = ref([])
const selectedELinkId = ref('')
const antiRefluxLoading = ref(false)
const uuidList = ref([])
const verificationCode = ref('')

// 表单数据
const formData = reactive({
  demand: 0,
  reactiveMode: 1, // 1-不出无功, 2-无功优先, 3-有功优先
  antiReflux: false,
  communicationMode: 1 // 1-按策略一直运行, 2-按策略运行第二天停机, 3-按策略工作休息制度运行
})

// 参数设置表单
const paramForm = reactive({
  transformerRatio: 0
})

// 用于存储操作前的原始值
const originalValues = reactive({
  reactiveMode: 1,
  transformerRatio: 0
})

// 当前正在修改无功工作模式的分组上下文
// uuidList 只装这一组的 eLink，避免把改动下发到全站
const currentReactiveTarget = ref(null)

// uuid -> 后端已生效的 reactiveMode，用于失败/取消时回滚下拉框
const reactiveModeSnapshot = new Map()

// 表单引用
const formRef = ref(null)
const paramFormRef = ref(null)

// 权限校验弹窗控制
const authDialogVisible = ref(false)
const pendingOperation = ref(null)

// 初始化函数
onMounted(async () => {
  await loadGroupList()
  await loadELinks()
  await getGroupSettingRecord()
  await getAuthConfig()
  await getStationSetting()
  if (eLinkList.value.length > 0) {
    selectedELinkId.value = eLinkList.value[0].uuid
    // uuidList.value = eLinkList.value.map(item => item.elink_id)
  }

  // 初始化时只判断本地有没有未过期的验证码，不做后端校验。
  // 之前这里会调 isVerificationValid() 发请求，用户什么都没操作就被提示「验证码无效」；
  // 真正的校验推迟到用户执行高风险操作时进行。
  // getSavedSmsCode() 内部会顺带清理已过期（超过 5 分钟）的验证码，
  // 并要求验证码归属于当前电站的手机号，否则视为不可用。
  verificationCode.value = getSavedSmsCode(phoneNumber.value)
})

const transformerData = ref([])
async function getStationSetting() {
  strategyApi.getStationSetting(stationId.value).then(res => {
    if (res.code === 200 && res.data.eLinkSettingList.length > 0) {
      if (res.data.sync) {
        paramForm.transformerRatio = res.data.eLinkSettingList[0].transfCapRatio
      } else {
        paramForm.transformerRatio = res.data.eLinkSettingList[0].transfCapRatio
        transformerData.value = res.data.eLinkSettingList
      }
    } else {
      transformerData.value = []
      paramForm.transformerRatio = 0.5
    }
  })
}

// 在组件卸载时清除计时器
onUnmounted(() => {
  // 清理工作
})

watch(stationId, async () => {
  await loadGroupList()
  await loadELinks()
  await getGroupSettingRecord()
  await getAuthConfig()
  await getStationSetting()
})

// 加载组列表
async function loadGroupList() {
  const res = await strategyApi.getGroupSettingList(stationId.value)
  if (res && Array.isArray(res.data)) {
    groupedElinkList.value = res.data
  } else {
    groupedElinkList.value = []
  }
  syncReactiveModeSnapshot()
}

// 记录后端返回的无功工作模式，作为回滚基准
// （v-model 会在 change 触发前就改掉视图上的值，拿不到旧值）
function syncReactiveModeSnapshot() {
  reactiveModeSnapshot.clear()
  groupedElinkList.value.forEach(group => {
    (group?.eLinkSettingList || []).forEach(elink => {
      if (elink?.uuid) reactiveModeSnapshot.set(elink.uuid, elink.reactiveMode)
    })
  })
}

// 加载eLink列表
async function loadELinks() {
  getAuthRole()
  getGroupSettingRecord()
  try {
    const res = await strategyApi.elinks(stationId.value)
    if (res && res.data) {
      eLinkList.value = res.data
      formData.communicationMode = Number(res.data[0].comm_timeout_stop_mode) || 1
    }

  } catch (error) {
    ElMessage.info('elink分组为空')
  }
}

const phoneNumber = ref('')
const preventCounterCurrent = ref(0)
const transformerCapacityRatio = ref(0)
const reactivePowerWorking = ref(0)
const isAuth = ref(false)
async function getAuthConfig() {
  await strategyApi.getStationStrategyConfig(stationId.value).then(res => {
    if (res.code == 200 && res.data) {
      // 显示权限校验弹窗
      phoneNumber.value = res.data.phoneNumber
      preventCounterCurrent.value = res.data.preventCounterCurrent
      transformerCapacityRatio.value = res.data.transformerCapacityRatio
      reactivePowerWorking.value = res.data.reactivePowerWorking
    } else {
      isAuth.value = false
    }
  })
}


// 无功工作模式变更处理
async function onReactiveModeChange(elinkSetting) {
  // 添加安全检查
  if (!elinkSetting || !elinkSetting.length || !elinkSetting[0]) {
    ElMessage.warning('无效的eLink设置')
    return
  }

  // 只取本分组的 eLink，下发范围严格限定在这一组
  const groupUuidList = elinkSetting.map(e => e?.uuid).filter(Boolean)
  if (!groupUuidList.length) {
    ElMessage.warning('无效的eLink设置')
    return
  }

  // 待下发的新值 = v-model 已经写入的值；回滚基准从快照取
  originalValues.reactiveMode = reactiveModeSnapshot.has(groupUuidList[0])
    ? reactiveModeSnapshot.get(groupUuidList[0])
    : elinkSetting[0].reactiveMode
  currentReactiveTarget.value = {
    elinkSetting,
    uuidList: groupUuidList,
    mode: elinkSetting[0].reactiveMode
  }

  isAuth.value = reactivePowerWorking.value
  if (reactivePowerWorking.value) {
    // 检查验证码是否有效
    const isValid = await isVerificationValid()
    if (isValid) {
      // 验证码有效，直接执行保存操作
      await saveReactiveMode()
      return
    }

    // 验证码无效，显示权限校验弹窗
    authDialogVisible.value = true
    pendingOperation.value = 'saveReactiveMode'
  } else {
    // 没有权限，恢复原始值
    rollbackReactiveMode()
    currentReactiveTarget.value = null
    // 显示权限校验弹窗
    authDialogVisible.value = true
  }
}

// 把本组下拉框恢复成后端已生效的值
function rollbackReactiveMode() {
  const target = currentReactiveTarget.value
  if (!target) return
  target.elinkSetting.forEach(elink => {
    if (elink) elink.reactiveMode = originalValues.reactiveMode
  })
}

// 保存通信中断运行模式
async function saveCommunicationMode() {
  uuidList.value = [];
  eLinkList.value.forEach(item => {
    uuidList.value.push(item.elink_id)
  })
  const saveData = {
    stationId: stationId.value,
    uuidList: uuidList.value,
    commTimeoutStopMode: String(formData.communicationMode),
  }

  // 直接调用API，无需验证码
  const res = await strategyApi.updateGroupSetting(saveData)
  if (res.code === 200) {
    ElMessage.success('通信中断运行模式保存成功')
    await loadELinks()
  } else {
    ElMessage.error(res.msg || '保存失败')
  }

}

// 保存参数设置
async function saveParamSettings() {
  // 保存操作前的原始值
  originalValues.transformerRatio = paramForm.transformerRatio
  isAuth.value = transformerCapacityRatio.value
  if (transformerCapacityRatio.value) {
    // 检查验证码是否有效
    const isValid = await isVerificationValid()
    if (isValid) {
      // 验证码有效，直接执行保存操作
      await saveTransformerRatio()
      return
    }

    // 验证码无效，显示权限校验弹窗
    authDialogVisible.value = true
    pendingOperation.value = 'saveParams'
  } else {
    // 没有权限，恢复原始值
    paramForm.transformerRatio = originalValues.transformerRatio
    // 显示权限校验弹窗
    authDialogVisible.value = true
  }
}

// 确认权限校验弹窗 - 修改此函数处理权限校验成功后的逻辑
async function confirmAuthDialog() {
  authDialogVisible.value = false

  // 根据不同的操作类型执行相应的保存逻辑
  if (pendingOperation.value === 'saveParams') {
    // 保存箱变容量变比
    await saveTransformerRatio()
  } else if (pendingOperation.value === 'saveReactiveMode') {
    // 保存无功工作模式
    await saveReactiveMode()
  }

  // 清除操作状态
  pendingOperation.value = null
  currentReactiveTarget.value = null
}

// 保存无功工作模式
async function saveReactiveMode() {
  // 获取当前存储的验证码（已过期、或不属于当前手机号的会返回空串）
  let smsCode = getSavedSmsCode(phoneNumber.value)

  // 验证验证码是否有效
  const isValid = await isVerificationValid()
  if (!isValid) {
    // 验证码无效，显示验证弹窗
    authDialogVisible.value = true
    return
  }
  const target = currentReactiveTarget.value
  if (!target) {
    ElMessage.warning('无效的eLink设置')
    return
  }

  try {
    const saveData = {
      stationId: stationId.value,
      uuidList: target.uuidList, // 只下发当前修改的这一组 eLink
      reactiveMode: target.mode
    }

    const res = await strategyApi.updateGroupSetting(saveData, smsCode)

    if (res.code === 200) {
      ElMessage.success('无功工作模式保存成功')
      // 下发成功后刷新分组数据，同时更新回滚快照
      await loadGroupList()
      await loadELinks()
      // 操作成功，无需清除验证码
    } else {
      ElMessage.error(res.msg || '保存失败')
      // 恢复原始值
      rollbackReactiveMode()
      if (res.code === 401 || res.msg?.includes('验证码')) {
        // 验证码失效，清除本地存储的验证码
        clearSmsCode()
        authDialogVisible.value = true
      }
    }
  } catch (error) {
    console.error('保存无功工作模式失败', error)
    ElMessage.error('保存失败: ' + (error.message || '未知错误'))
    // 恢复原始值
    rollbackReactiveMode()
  }
}

// 保存箱变容量变比
async function saveTransformerRatio() {
  // 获取当前存储的验证码（已过期、或不属于当前手机号的会返回空串）
  let smsCode = getSavedSmsCode(phoneNumber.value)

  // 验证验证码是否有效
  const isValid = await isVerificationValid()
  if (!isValid) {
    // 验证码无效，显示验证弹窗
    authDialogVisible.value = true
    return
  }
  uuidList.value = []
  eLinkList.value.forEach(item => {
    uuidList.value.push(item.elink_id)
  })


  try {
    const saveData = {
      stationId: stationId.value,
      uuidList: uuidList.value,
      transfCapRatio: paramForm.transformerRatio
    }

    const res = await strategyApi.updateGroupSetting(saveData, smsCode)

    if (res.code === 200) {
      ElMessage.success('箱变容量变比保存成功')
      await loadELinks()
      setTimeout(() => {
         getStationSetting()
      }, 3000);
    
      // 操作成功，无需清除验证码
    } else {
      ElMessage.error(res.msg || '保存失败')
      // 恢复原始值
      paramForm.transformerRatio = originalValues.transformerRatio
      if (res.code === 401 || res.msg?.includes('验证码')) {
        // 验证码失效，清除本地存储的验证码
        clearSmsCode()
        authDialogVisible.value = true
      }
    }
  } catch (error) {
    console.error('保存箱变容量变比失败', error)
    ElMessage.error('保存失败: ' + (error.message || '未知错误'))
    // 恢复原始值
    paramForm.transformerRatio = originalValues.transformerRatio
  }
}

// 处理带验证码的确认逻辑
function onConfirmWithCode(code) {
  // 保存验证码
  verificationCode.value = code

  // 保存到localStorage中，记录写入时间（5 分钟过期的计时起点）与所属手机号
  saveSmsCode(phoneNumber.value, code)

  // 关闭弹窗
  authDialogVisible.value = false

  // 执行确认逻辑
  confirmAuthDialog()
}

// 获取无功工作模式文本
function getReactiveModeText(mode) {

  const modeMap = {
    0: '不出无功',
    1: '不出无功',
    2: '优先出无功',
    3: '优先出有功'
  }
  return modeMap[mode] || '未知'
}

// 取消权限校验弹窗
function cancelAuthDialog() {
  authDialogVisible.value = false

  // 如果取消权限验证，恢复原始值
  if (pendingOperation.value === 'saveReactiveMode') {
    rollbackReactiveMode()
  } else if (pendingOperation.value === 'saveParams') {
    paramForm.transformerRatio = originalValues.transformerRatio
  }

  pendingOperation.value = null
  currentReactiveTarget.value = null
}


// 获取高级配置操作日志
async function getGroupSettingRecord() {
  const res = await strategyApi.getGroupSettingRecord({
    page: 1,
    pageSize: 99999,
    stationId: stationId.value
  })
  if (res && res.rows) {
    strategyLogList.value = res.rows
  }
}

const strategyLogList = ref([])
const isDeveloper = ref(false)
function getAuthRole() {
  const roleString = sessionStorage.getItem('user-info')
  // 确保roleString是有效的JSON字符串，并解析为数组
  try {
    const roleArray = JSON.parse(roleString || '[]')
    console.log(roleArray)
    // 检查roleArray是否是数组
    if (Array.isArray(roleArray.roles)) {
      // 遍历数组，检查是否包含角色字符
      isDeveloper.value = roleArray.roles.some(item => (item === 'user' || item === 'test-1' || item === 'zsdzsdf10' || item === 'zsdzsdf11' || item === 'software' || item === 'development_low' || item === 'admin'))
      console.log('isDeveloper', isDeveloper.value)
    } else {
      isDeveloper.value = false
    }
  } catch (error) {
    console.error('解析user-info失败:', error)
    isDeveloper.value = false
  }
}

</script>

<style lang="scss" scoped>
.advanced-config-container {
  width: 100%;
  height: 100%;
  padding: 16px;
  box-sizing: border-box;
  background-color: #f5f7fa; // 整体背景改为浅灰
  font-family: "HarmonyOS Sans SC", PingFang SC, Microsoft YaHei, sans-serif;

  .main-content {
    display: flex;
    width: 100%;
    height: 100%;
    gap: 16px;

    .left-panel {
      flex: 7;
      display: flex;
      flex-direction: column;
      gap: 16px;
      height: 100%;
      width: 80%;
      overflow-y: auto; // 允许左侧滚动

      &::-webkit-scrollbar {
        width: 4px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #c0c4cc;
        border-radius: 4px;
      }

      &::-webkit-scrollbar-track {
        background-color: transparent;
        border-radius: 4px;
      }

      .section-card {
        background: #ffffff;
        border-radius: 16px; // 圆角加大
        padding: 20px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05); // 添加轻微阴影
        border: none; // 去掉边框

        .section-title {
          border-left: 4px solid #3a68ff; // 蓝色条
          padding-left: 12px;
          font-family: "HarmonyOS Sans SC", sans-serif;
          font-weight: 600;
          font-size: 16px;
          color: #2e2e2e; // 深色标题
          line-height: 1;
          text-align: left;
          margin-bottom: 20px;
          display: flex;
          align-items: center;
        }

        .group-block-container {
          display: flex;
          flex-flow: row;
          overflow-x: auto;
          padding-bottom: 10px;

          &::-webkit-scrollbar {
            height: 6px;
          }

          &::-webkit-scrollbar-thumb {
            background-color: #c0c4cc;
            border-radius: 4px;
          }

          &::-webkit-scrollbar-track {
            background-color: #f5f7fa;
            border-radius: 4px;
          }

          .empty-card {
            margin-left: 50%;
            transform: translateX(-50%);
          }
        }

        .group-block {
          background: #f5f7fa; // 浅灰背景
          border-radius: 12px;
          padding: 16px;
          margin-right: 20px;
          cursor: pointer;
          transition: all 0.3s;
          border: 1px solid transparent;
          display: flex;
          flex-direction: column;
          min-width: 280px; // 保证卡片宽度

          &:hover:not(.active) {
            background: #eef3ff; // 悬停浅蓝
            border-color: #3a68ff;
            box-shadow: 0 4px 12px rgba(58, 104, 255, 0.1);
          }

          .card-header {
            display: flex;
            align-items: center;
            margin-bottom: 16px;
            border-bottom: 1px solid #e4e7ed;
            padding-bottom: 10px;

            .card-index {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 28px;
              height: 28px;
              background: #3a68ff; // 蓝色背景
              color: #fff;
              border-radius: 50%;
              font-weight: bold;
              font-size: 14px;
              margin-right: 10px;
            }

            .group-name {
              font-weight: 600;
              font-size: 15px;
              color: #2e2e2e;
            }
          }

          .card-body {
            padding: 5px 0;

            .elink-details {
              background: #ffffff;
              border-radius: 8px;
              padding: 12px;
              border: 1px solid #ebeef5;
              margin-bottom: 15px;

              .elink-list-section {
                display: flex;
                flex-direction: column; // 改为垂直排列，避免过宽

                .elink-list-section-card {
                  margin-bottom: 10px;
                  background: transparent;
                  border: none;
                  box-shadow: none;

                  &:last-child {
                    margin-bottom: 0;
                  }

                  :deep(.el-card__body) {
                    padding: 0;
                  }
                }

                .detail-item {
                  display: flex;
                  margin-bottom: 8px;
                  font-size: 13px;

                  &:last-child {
                    margin-bottom: 0;
                  }

                  .item-label {
                    width: 100px;
                    text-align: right;
                    padding-right: 10px;
                    color: #606266; // 灰色文字
                    flex-shrink: 0;
                  }

                  .item-value {
                    flex: 1;
                    text-align: left;
                    color: #303133; // 深色文字
                    font-weight: 500;
                  }
                }
              }
            }

            .group-settings-section {
              margin-top: 15px;
              background: #ffffff;
              border-radius: 8px;
              padding: 12px;
              border: 1px solid #ebeef5;

              .setting-item {
                display: flex;
                margin-bottom: 16px;

                &:last-child {
                  margin-bottom: 0;
                }

                .setting-label {
                  font-size: 14px;
                  color: #606266;
                  font-weight: 500;
                }

                .setting-control {
                  display: flex;
                  align-items: center;

                  .el-select {
                    width: 100%;
                  }
                }

                &.vertical-item {
                  flex-direction: column;

                  .setting-label {
                    margin-bottom: 8px;
                  }

                  .setting-control {
                    width: 100%;
                  }
                }
              }
            }
          }
        }

        .section-content {
          padding: 0;
        }
      }

      .section-card-group {
        // height: 60%; // 移除固定高度，让内容自适应
        min-height: 400px;
      }
    }

    .right-panel {
      flex: 3; // 稍微加宽右侧
      background: #ffffff;
      border-radius: 16px;
      padding: 20px;
      height: 100%;
      overflow-y: auto;
      display: flex;
      flex-direction: column;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
      border: none;

      .section-title {
        border-left: 4px solid #3a68ff;
        padding-left: 12px;
        font-family: "HarmonyOS Sans SC", sans-serif;
        font-weight: 600;
        font-size: 16px;
        color: #2e2e2e;
        line-height: 1;
        text-align: left;
        margin-bottom: 20px;
      }

      :deep(.page-container) {
        flex: 1;
        overflow: hidden;
      }
    }
  }

  .communication-mode-container {
    .mode-selection {
      background: #f5f7fa;
      border-radius: 12px;
      padding: 20px;

      .mode-options {
        margin-bottom: 20px;
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        align-items: center;

        .el-radio-group {
          display: flex;
          flex-wrap: wrap;
          gap: 16px;
        }

        .el-radio {
          margin-right: 0;
          color: #606266;
          
          &.is-checked {
             .el-radio__label {
               color: #3a68ff;
             }
          }
        }
        
        // 按钮样式优化
        .el-button {
           background-color: #3a68ff;
           border-color: #3a68ff;
           border-radius: 8px;
           padding: 8px 16px;
           font-weight: 500;
           
           &:hover {
             opacity: 0.9;
           }
        }
      }

      .mode-description {
        background: #ffffff;
        border-radius: 8px;
        padding: 16px;
        border: 1px solid #ebeef5;
        max-height: 150px;
        overflow: auto;

        .subtitle {
          font-size: 14px;
          font-weight: bold;
          color: #303133;
          margin-bottom: 10px;
        }

        .desc-text {
          font-size: 13px;
          color: #606266;
          line-height: 1.6;

          .sub-item {
            margin-top: 10px;

            .sub-item-title {
              font-weight: 600;
              color: #303133;
              margin-bottom: 4px;
            }

            .sub-item-desc {
              padding-left: 15px;
              margin-bottom: 8px;
            }
          }
        }
      }
    }
  }

  // 权限校验弹窗样式 - 适配浅色
  .auth-dialog-content {
    display: flex;
    background-color: #ffffff; // 浅色背景
    border-radius: 8px;
    padding: 20px 30px;

    .auth-left {
      flex: 1;

      .phone-verify {
        margin-bottom: 20px;
        padding-bottom: 20px;
        border-bottom: 1px solid #ebeef5;

        .phone-input {
          display: flex;
          align-items: center;
          margin-bottom: 15px;

          .label {
            color: #606266;
            margin-right: 10px;
            min-width: 60px;
          }

          .value {
            color: #303133;
            font-weight: 500;
          }
        }

        .code-input {
          display: flex;
          margin-bottom: 15px;
          align-items: center;

          .label {
             color: #606266;
             margin-right: 10px;
          }

          .code-field {
            flex: 1;
            margin-right: 10px;

            :deep(.el-input__inner) {
              background-color: #ffffff;
              border-color: #dcdfe6;
              color: #303133;
              
              &:focus {
                border-color: #3a68ff;
              }
            }
          }

          .send-btn {
            min-width: 120px;
            background-color: #3a68ff;
            border-color: #3a68ff;
          }
        }

        .confirm-btn {
          display: flex;
          justify-content: flex-end;
          gap: 10px;
        }
      }
    }

    .auth-text {
      flex: 1;

      .auth-item {
        font-size: 14px;
        color: #606266;
        line-height: 1.8;
        margin-bottom: 10px;
        text-align: left;

        &:last-child {
          margin-top: 20px;
          color: #909399;
          font-style: italic;
        }
      }
    }
  }

  // 修改element-plus弹窗样式
  :deep(.el-dialog) {
    background-color: #ffffff;
    border-radius: 12px;
    box-shadow: 0 4px 24px rgba(0,0,0,0.1);

    .el-dialog__header {
      margin: 0;
      padding: 20px;
      background-color: #ffffff;
      border-bottom: 1px solid #ebeef5;
      border-radius: 12px 12px 0 0;

      .el-dialog__title {
        color: #303133;
        font-size: 18px;
        font-weight: 600;
      }
    }

    .el-dialog__body {
      padding: 20px;
      color: #606266;
    }

    .el-dialog__footer {
      padding: 10px 20px 20px;
      border-top: 1px solid #ebeef5;
    }
  }
}

// 添加表单相关样式
.param-form {
  margin: 10px 0;

  :deep(.el-form-item) {
    margin-bottom: 20px;
    
    .el-form-item__label {
      color: #606266;
    }
  }

  .form-input-row {
    display: flex;
    align-items: center;
    gap: 20px;

    .transformer-ratio-input {
      width: 180px;
    }

    .save-btn {
      min-width: 100px;
      background-color: #3a68ff;
      border-color: #3a68ff;
      border-radius: 8px;
      color: #ffffff;
      font-size: 12px;
    }
  }

  // 修改时间线的样式
  ::v-deep .timeline-dot-symbol {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 3px solid #3a68ff !important;
    background: #ffffff;
  }

  ::v-deep .el-timeline-item__tail {
    border-left: 2px solid #e4e7ed; // 浅色线条
    left: 7px;
    top: 15px;
    bottom: 16px;
  }
  
  ::v-deep .el-timeline-item__timestamp {
     color: #909399;
  }

  .card-container {
    width: 100%;
    background-color: #f5f7fa;
    border-radius: 8px;
    padding: 12px;
    border: 1px solid #ebeef5;

    .item-container {
      width: 100%;
      display: flex;
      line-height: 24px;
      font-family: PingFang-SC, PingFang-SC;
      font-size: 14px;
      color: #303133;

      .title {
        width: 80px;
        text-align: right;
        color: #606266;
      }

      .content {
        width: 200px;
        flex: 1 1 auto;
        word-wrap: break-word;
        color: #303133;
      }
    }
  }
}

// 添加表格与表单左右布局样式
.param-form-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  .param-form {
    flex: 1;
    margin-right: 20px;
    min-width: 250px;
  }

  .transformer-table {
    width: 80%;
    margin-left: 20px; // 调整间距
    margin-top: 0; // 调整对齐
    overflow-y: auto;
    border: 1px solid #ebeef5;
    border-radius: 8px;

    :deep(.el-table__header) {
      th {
        background-color: #f5f7fa !important;
        color: #606266;
        font-weight: 600;
      }
    }

    :deep(.el-table__body) {
      background-color: #ffffff;
    }

    :deep(.el-table__cell) {
      color: #606266;
      border-bottom-color: #ebeef5;
    }
    
    :deep(.el-table__row:hover > td) {
       background-color: #f5f7fa !important;
    }
  }
}
</style>
